import React, {useEffect, useRef, useState,Fragment} from 'react';
import "./TagRegalDesktopV3.scss";
import {useHistory} from "react-router-dom";
import {convertVariantTypeNameWithVal, getMallColor} from "../../Services";
import {getCats_api, getProductsByTags_api, getProductsCategory_api} from "../../Services/apis";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Col, message, Row, Spin} from 'antd';
import SwiperId from "react-id-swiper";
import {PlusOutlined} from '@ant-design/icons';
import {useBasket, useDispatchBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../OnlineAddress/OnlineAddressService";
import SwiperCore,{ Autoplay, Pagination, Navigation } from "swiper";

const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        400: {
            slidesPerView: 'auto',
            spaceBetween: 8
        },
        320: {
            slidesPerView: 'auto',
            spaceBetween: 8
        }
    }

}


const catParams = {
    slidesPerView: 8,
    spaceBetween: 2,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function BasketAddRemoveSub({product,handleChangeProduct,changeOut}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const history = useHistory();

    //states
    const [loading, set_loading] = useState(false)
    const [base, set_base] = useState(product)
    const [item, set_item] = useState(null)
    const [merchantId,set_merchantId] = useState(product.merchant.uid)


    useEffect(() => {
        if(product?.variants?.length > 0) {
            set_item(product.variants[0])
        }else{
            set_item(product)
        }
    }, [])

    const addToBasket = async (pId) => {
        const response = await AddBasket(merchantId, pId,item)
        console.log("Add : ", response)
    }

    const removeFromBasket = async (pId) => {
        const response = await RemoveBasket(merchantId, pId)
        console.log("Remove : ", response)
    }

    //functions
    const inc = async () => {
        console.log("ssssssssssssssssssss")
        if (loading) {
            return
        }

        let pickCount = basket.find(p=>p.product.uid===product.uid)

        if(pickCount && product.stock<pickCount.count+1){
            return message.error('درخواست شما بیشتر از سقف موجودی است');
        }

        if(pickCount && product.order_cap<pickCount.count+1){
            return message.error('درخواست شما بیشتر از سقف خرید است');
        }


        try {
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if (basket.find(product => product.product.uid === item.uid)) {
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count + 1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket", JSON.stringify(filter));
        } else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product: item, count: 1}]);
            //storage change
            localStorage.setItem("basket", JSON.stringify([...basket, {product: item, count: 1}]));
        }


    }

    const dec = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product => product.product.uid === item.uid);
        if (find) {
            //exist
            if (find.count > 0) {
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count - 1} : pro)

                if (find.count === 1) {
                    //context change
                    setBasket(basket.filter(product => product.product.uid !== item.uid))
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                } else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(filter));
                }
            } else {
                //context change
                setBasket(basket.filter(product => product.product.uid !== item.uid))
                //storage change
                localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
            }
        }


    }

    const remove = () => {
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product => product?.product?.uid !== item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(() => {
            localStorage.setItem("basket", JSON.stringify(basket));
        }, 500)
    }

    const checkCount = () => {
        if(!item)
            return 0

        let basket_count = basket.find(product => product?.product?.uid === item.uid);
        if (basket_count) {
            return basket_count.count;
        }
        return 0;
    }

    const handleVariantChange = (vId)=>{
        const  find = base.variants.find(v=>v.uid===vId)
        console.log("find : ",find)
        set_item(find)
        handleChangeProduct(find)
    }

    useEffect(()=>{
        set_item(changeOut)
    },[changeOut])

    return (
        <div>
            {/*{base?.variants?.length > 0 ?*/}
            {/*    <div className="var-section">*/}
            {/*        <select*/}
            {/*            onChange={e=>{*/}
            {/*                handleVariantChange(e.target.value)*/}
            {/*            }}*/}
            {/*            name="" id="">*/}
            {/*            {base.variants.map(v=>{*/}
            {/*                return(*/}
            {/*                    <option value={v.uid}>{convertVariantTypeNameWithVal(v.variant_type,v.variant_attr)}</option>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*        </select>*/}
            {/*    </div>:*/}
            {/*    null*/}
            {/*}*/}

            {item && checkCount() > 0?<div className="dr-shop-add-remove-v2-change">
                {item && checkCount() > 0 ? <>
                    <i className="clickable fa fa-minus" onClick={dec}></i>
                    <span className="plusIcon product-count-number-v2">{!loading ? checkCount() : <i className="fa fa-spinner fa-spin"></i>}</span>
                </> : null}
                {item.stock>checkCount()?
                    <i className="clickable fa fa-plus" onClick={inc}></i>:
                    <span></span>
                }

            </div>:null}

            {item && checkCount() < 1?<div>
                {!loading?<i className="clickable plusIcon fa fa-plus" onClick={inc}></i>:
                    <i className="plusIcon fa fa-spinner fa-spin"></i>
                }


            </div>:null}


        </div>
    )
}



function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}


function ProductV2Card({product,item}){

    const history = useHistory()





    const [p,set_p] = useState(product)

    const goToProductDetail = ()=>{
        if(product.variants && product.variants.length > 0)
            history.push(`/dr-shop/detail/${product.merchant.uid}/${product.uid}`,{variant: p})
        else
            history.push(`/dr-shop/detail/${product.merchant.uid}/${product.uid}`)
    }

    useEffect(()=>{

        let split = item.items[0].text.split("@");
        let merchantId = split[0]
        let tagId = split[1]


        if(product.variants && product.variants.length>0){

            let target = null;
             product.variants.forEach(v=>{
                v.tags.forEach(t=>{
                    if(t.uid===tagId)
                        target = v
                })
            })

            console.log("Target : ",target)

            if(target)
                set_p({...target,merchant:product.merchant})
            else
            set_p({...product.variants[0],merchant:product.merchant})
        }else{
            set_p(product)
        }
    },[])

    const handleChangeProduct = (pr)=>{
        console.log("product : ",pr)
        set_p(pr)
    }
    const handleChangeVar = (vId)=>{
        let find = product.variants.find(v=>v.uid===vId)
        set_p({...find,merchant:product.merchant})
    }
    return(
                <div className="p-regal-desktop-v2-products-card">
                    <Fragment>
                        <div className="add-section">
                            <BasketAddRemoveSub product={p}handleChangeProduct={handleChangeProduct} changeOut={p}/>
                        </div>
                        <div className="p-regal-desktop-v2-products-card-wrapper" >
                            <div className="p-regal-desktop-v2-products-card-img pointer" onClick={e=>{
                                goToProductDetail()
                            }}>
                                <img
                                    src={p.image}
                                    alt=""/>
                            </div>
                            <div className="p-regal-desktop-v2-products-card-divider">
                                {/*<PlusOutlined />*/}
                            </div>
                            <div className="p-regal-desktop-v2-products-card-info" >
                                <span className="p-regal-desktop-v2-products-card-info-name">{limitText(p.name,50)}</span>
                                <span className="p-regal-desktop-v2-products-card-info-brand">{p?.brand?.name}</span>
                                {product.variants.length>1?
                                    <select
                                        className="var-select"
                                        value={p.uid}
                                        onChange={e=>{
                                            handleChangeVar(e.target.value)
                                        }}
                                        name="" id="">
                                        {product.variants.map(v=>{
                                            if(v.is_active){
                                                return(
                                                    <option value={v.uid}>{convertVariantTypeNameWithVal(v.variant_type,v.variant_attr)}</option>
                                                )
                                            }
                                        })}
                                    </select>:null
                                }

                            </div>

                            <div className="p-regal-desktop-v2-products-card-footer" onClick={e=>{
                                goToProductDetail()
                            }}>


                                <div className="p-regal-desktop-v2-products-card-footer-badge">
                                    {p && p.discount_percentage && p.discount_percentage>0?<div className="p-regal-desktop-v2-products-card-footer-badge-off">
                                        <span>%{p.discount_percentage}</span>
                                    </div>:null}
                                </div>

                                <div className="p-regal-desktop-v2-products-card-footer-price">
                                    {p.price_original-p.price>0?
                                        <span className="p-regal-desktop-v2-products-card-footer-price-off">{numberWithCommas(p.price_original/10)}</span>:
                                        <span></span>}
                                    <span className="p-regal-desktop-v2-products-card-footer-price-price">{numberWithCommas(p.price/10)} تومان</span>
                                </div>

                            </div>
                        </div>

                    </Fragment>
                </div>

    )
}

function TagRegalDesktopV3({item,sort=false}) {

    SwiperCore.use([Autoplay])
    const history = useHistory();

    const [cats,set_cats] = useState([]);
    const [selectedCat,set_selectedCat] = useState(null);
    const [products,set_products] = useState([]);
    const [cat_banner,set_cat_banner] = useState("")
    const [cat_name,set_cat_name] = useState("")
    const [spin,set_spin] = useState(false)


    useEffect(()=>{
        getCat()
    },[])

    const getCat = async ()=>{
        set_spin(true)
        let split = item.items[0].text.split("@");
        let merchantId = split[0]
        let tagId = split[1]
        try{
            const res = await getProductsByTags_api(merchantId, tagId)
            set_cat_banner(res.category_image)
            set_cat_name(res.category_name)
            set_products([])
            set_products(res.results)
            set_spin(false)
        }catch (e) {
            set_spin(false)
            console.log(e)
        }
    }

    const seeMoreProduct = ()=>{
        let merchantId = selectedCat.text
        let catId = selectedCat.link_to_uid
        history.push(`/dr-shop/search/${merchantId}/${catId}`)
    }

    return(
        <div className="p-regal-desktop-v2-container">
            <Row className="v2-wrapper" style={{backgroundColor:item.items[0]?.subtitle}}>
                <Col className="left-slider v2-card-color"  span={20}>
                    <Spin spinning={spin}>
                        <Row>
                            <div className="p-regal-container">
                                <Swiper
                                    autoplay={{
                                        delay: 3000,
                                        pauseOnMouseEnter: true,
                                        disableOnInteraction: false
                                    }}
                                    loop={false}
                                    dir={"rtl"}
                                    spaceBetween={10}
                                    slidesPerView={5}
                                    modules={[Autoplay, Pagination, Navigation]}
                                    onSlideChange={() => console.log('slide change')}
                                    onSwiper={(swiper) => console.log(swiper)}
                                >
                                    {products.map(i=>{
                                        return(
                                            <SwiperSlide>
                                                <ProductV2Card item={item} product={i}/>
                                            </SwiperSlide>
                                        )
                                    })}
                                </Swiper>
                            </div>


                        </Row>
                    </Spin>


                </Col>

                <Col className="right-slider" span={4}>
                    <div className="p-regal-desktop-v3-banner-sec">
                        <img src={item.items[0]?.image} alt=""/>
                        <h6>{item.items[0]?.title}</h6>
                        {/*<span className="clickable" onClick={seeMoreProduct}>مشاهده همه</span>*/}
                    </div>
                </Col>

            </Row>




        </div>
    )
}

export default TagRegalDesktopV3;
